import { TextField, styled } from '@mui/material';

export const CustomFormTextField = styled(TextField)(() => ({
  '& label.Mui-focused': {
    color: `black`,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: `white !important`,
  },
  '& .MuiInput-underline:before': {
    borderBottom: `white !important`,
  },
  '& .MuiInputBase-input': {
    fontFamily: 'Suisse-Intl',
    fontSize: 16,
  },
  '& .MuiFormLabel-root': {
    fontFamily: 'Suisse-Intl',
    color: `black`,
    fontSize: 12,
  },
}));

export const DropDownHeader = styled('div')(() => ({
  borderBottom: `2px solid black`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const DropDownArrow = styled('span')({
  marginBottom: 1,
});

export const DropDownContainer = styled('div')(({ customStyle = {} }) => ({
  width: '100%',
  margin: '0 auto',
  position: 'relative',
  ...customStyle,
}));

export const DropDownListContainer = styled('div')({
  zIndex: '100',
  position: 'absolute',
  width: '100%',
  top: 65,
  height: 300,
  '& > div::-webkit-scrollbar': {
    width: 6,
  },
  '& > div::-webkit-scrollbar-track': {
    background: '#ffffff',
  },
  '& > div::-webkit-scrollbar-thumb': {
    background: 'rgba(149, 152, 154, 0.43)',
    borderRadius: 5,
  },
  '& > div::-webkit-scrollbar-thumb:hover': {
    background: 'rgba(149, 152, 154, 1)',
  },
});

export const DropDownList = styled('div')(({ customStyle = {} }) => ({
  marginBottom: '20px',
  padding: 10,
  background: '#ffffff',
  boxShadow: '0 6px 12px rgb(0 0 0 / 18%)',
  height: 300,
  overflow: 'auto',
  color: `black`,
  '&:first-child': {
    paddingTop: '0.8em',
  },
  ...customStyle,
}));
export const ListItem = styled('div')(({ customTheme }) => ({
  listStyle: 'none',
  padding: ' 5px 15px',
  '&:hover': {
    color: `${customTheme.palette.primary.main}`,
    cursor: 'pointer',
  },
}));
